// extracted by mini-css-extract-plugin
module.exports = {"info":"_1DJnYtOMeYgdQXfLp_1Hjy"};